<template>
  <section>
    <div class="container">
      <div class="profile-author mb-4 mb-lg-5"></div>
      <div class="row">
        <div class="woocommerce">
          <div class="text-danger" v-if="error && !payment">
            {{ error }}
          </div>
          <div class="woocommerce-order" v-if="payment">
            <p
              class="woocommerce-notice woocommerce-notice--success woocommerce-thankyou-order-received"
            >
              Thank you. Your order has been received.
            </p>

            <ul
              class="woocommerce-order-overview woocommerce-thankyou-order-details order_details"
            >
              <li class="woocommerce-order-overview__order order">
                Order number: <strong>{{ orderNumber }}</strong>
              </li>

              <li class="woocommerce-order-overview__date date">
                Date: <strong>{{ orderDate }}</strong>
              </li>

              <li class="woocommerce-order-overview__total total">
                Total:
                <strong
                  ><span class="woocommerce-Price-amount amount"
                    >{{ transction.instructed_amount.amount }}<span class="woocommerce-Price-currencySymbol ml-1">{{ currency.symbol }}</span
                    ></span
                  ></strong
                >
              </li>

              <li class="woocommerce-order-overview__payment-method method">
                Payment method: <strong>Bank Payment</strong>
              </li>
            </ul>

            <div class="mb-4 text-danger" v-if="error">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
              {{ error }}
            </div>
            <div class="mb-4" v-else-if="!acceptedPayment">
              <LoaderPic />
              Waiting payment confirmation...
            </div>
            <div class="mb-4" v-else>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
              Your payment has been confirmed! We will dispatch your order soon.
            </div>

            <section class="woocommerce-order-details">
              <h2 class="woocommerce-order-details__title">Order details</h2>

              <table
                class="woocommerce-table woocommerce-table--order-details shop_table order_details"
              >
                <thead>
                  <tr>
                    <th class="woocommerce-table__product-name product-name">
                      Product
                    </th>
                    <th class="woocommerce-table__product-table product-total">
                      Total
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr class="woocommerce-table__line-item order_item">
                    <td class="woocommerce-table__product-name product-name">
                      <a
                        href=""
                        class="mr-1"
                        >Product – Name &amp; Short Description</a
                      >
                      <strong class="product-quantity">× {{ productCount }}</strong>
                    </td>

                    <td class="woocommerce-table__product-total product-total">
                      <span class="woocommerce-Price-amount amount"
                        >{{ orderTotal }}<span class="woocommerce-Price-currencySymbol ml-1">{{ currency.symbol }}</span
                        ></span
                      >
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <th scope="row">Subtotal</th>
                    <td>
                      <span class="woocommerce-Price-amount amount"
                        >{{ orderTotal }}<span class="woocommerce-Price-currencySymbol ml-1">{{ currency.symbol }}</span
                        ></span
                      >
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Total</th>
                    <td>
                      <span class="woocommerce-Price-amount amount"
                        >{{ transction.instructed_amount.amount }}<span class="woocommerce-Price-currencySymbol ml-1">{{ currency.symbol }}</span
                        ></span
                      >
                    </td>
                  </tr>
                </tfoot>
              </table>
            </section>
          </div>
          <div v-if="error || payment">
            <a href="/">Make another order</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import constants from '../constants.js'
import BaseService from '../services/BaseService.js'
import LoaderPic from '../components/elements/LoaderPic.vue'

export default {
  name: 'complete',
  components: {
    LoaderPic
  },
  data () {
    return {
      loading: false,
      acceptedPayment: false,
      country: '',
      aspspName: '',
      payment: null,
      error: null,
      orderNumber: '',
      orderDate: '',
      orderTotal: '0.00',
      productCount: 0,
      productPrice: '0.00'
    }
  },
  computed: {
    transction () {
      if (this.payment && this.payment.credit_transfer_transaction) {
        return this.payment.credit_transfer_transaction[0]
      }
      return null
    },
    currency () {
      const currencyCode = this.transction ? this.transction.instructed_amount.currency : 'EUR'
      return {
        code: currencyCode,
        symbol: constants.currencySymbols[currencyCode] || currencyCode
      }
    }
  },
  methods: {
    async confirmPayment () {
      try {
        const r = await BaseService.confirmPayment(window.location.href)
      } catch (e) {
        this.error = 'Unable to confirm the payment. Please start over'
      } finally {
        if (window.location.search || window.location.hash) {
          window.location.href = window.location.pathname
        }
      }
    },
    scheduleUpdate (timeout) {
      setTimeout(this.updateStatus, timeout)
    },
    async updateStatus () {
      try {
        const r = await BaseService.getPayment()
        if (r.data.payment_status === "ACCEPTED") {
          this.acceptedPayment = true
        } else if (r.data.payment_status === "REJECTED") {
          this.error = 'Payment request has been rejected. Please try using another account'
        } else {
          this.scheduleUpdate(1000)
        }
      } catch (e) {
        this.error = 'Unable to complete the payment. Please start over'
      }
    }
  },
  async mounted () {
    try {
      this.orderNumber = window.localStorage.getItem('orderNumber')
      this.orderDate = window.localStorage.getItem('orderDate')
      this.orderTotal = window.localStorage.getItem('orderTotal')
      this.productCount = window.localStorage.getItem('productCount')
      this.productPrice = window.localStorage.getItem('productPrice')
      const r = await BaseService.getPayment()
      if (r.data.payment) {
        this.payment = r.data.payment
        if (r.data.payment_status === "INITIATED") {
          this.confirmPayment()
        } else if (r.data.payment_status === "ACCEPTED") {
          this.acceptedPayment = true
        } else if (r.data.payment_status === "FAILED") {
          this.error = 'Unable to complete the payment. Please start over'
        } else {
          this.scheduleUpdate(1000)
        }
      }
    } catch (e) {
      this.error = 'Unable to retrieve payment data'
    } finally {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style1.css";
@import "../assets/woocommerce.css";
.bi-check-circle {
  width: 60px;
  height: 60px;
  padding: 15px;
  path {
    fill: #0B6367;
  }
}
.bi-x-circle {
  width: 60px;
  height: 60px;
  padding: 15px;
  path {
    fill: #E72536;
  }
}
</style>
